import React from "react";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

import { sectionIds } from "./section-ids";

const sections = [
  {
    title: "How We Got Here",
    description: (
      <>
        <strong>Residential solar grew fast. Too fast for its infrastructure.</strong> Companies cobbled together a CRM,
        a design tool, a finance portal, a spreadsheet. Nobody designed those tools to work together — they just
        accumulated. At low volume, messy was manageable. But you can’t scale messy.
      </>
    ),
  },
  {
    title: "The Infrastructure Gap",
    description: (
      <>
        <strong>Residential solar has hit a wall; every maturing industry does eventually.</strong> The Real Estate
        industry built MLS. Healthcare built EHR, Financial services built Bloomberg. A $30–40B industry can’t run on
        duct tape. It needs a shared layer — common infrastructure every participant can build on and benefit from.
      </>
    ),
  },
  {
    title: "The OS Layer",
    description: (
      <>
        <strong>Enerflo is that operating system. Not another tool. Not another app.</strong> It’s the infrastructure
        layer that connects them into one flow, where data moves from design to financing to contract without manual
        handoffs, enabling companies to run every deal through one system with greater speed, accuracy, and visibility.
      </>
    ),
  },
];

const title = "Why Residential Solar Companies Need An Operating System (OS), Not Another Tool";

const GrewFast = () => {
  return (
    <HeroSection title={title} className="bg-white" id={sectionIds.grewFast}>
      <HeroSection.Content className="space-y-10">
        <header className="text-center mb-12">
          <HeroSection.Tagline className="text-primary mb-8">{title}</HeroSection.Tagline>
          <Heading tag="h2" className="mb-6">
            <span className="text-primary">Residential solar grew fast.</span>
            <br />
            <span className="text-navy-dark max-w-4xl mx-auto inline-block mt-2">Too fast for its infrastructure.</span>
          </Heading>
          <p className="text-lg text-gray-600 max-w-5xl mx-auto">
            Solar companies have been cobbling together different tools, apps and systems to manage their sales and
            installs for years. Those tools were never designed to work together. Enerflo is the infrastructure layer
            the residential solar industry needs to scale.
          </p>
        </header>

        <div className="flex flex-col gap-4 lg:gap-8 lg:flex-row">
          {sections.map((section, index) => (
            <div key={section.title} className="bg-gray-100 rounded-xl p-4 flex flex-col justify-around md:p-6">
              <div>
                <HeroSection.Tagline className="text-primary">Act 0{index + 1}</HeroSection.Tagline>
                <Heading tag="h3" size="h5">
                  {section.title}
                </Heading>
              </div>
              <p className="mt-4">{section.description}</p>
            </div>
          ))}
        </div>
      </HeroSection.Content>
    </HeroSection>
  );
};

export default GrewFast;
